/* eslint-disable no-alert -- Giữ tương thích phản hồi UX của form landing page hiện tại. */
// eslint-disable-next-line import/no-unresolved -- Resolver ESLint cũ không hiểu package exports của v29.
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
// eslint-disable-next-line import/no-unresolved -- Resolver ESLint cũ không hiểu package exports của v29.
import 'intl-tel-input/styles-no-assets';
import '../../css/ldp/_event-registration-form.scss';

const config = window.jwEventRegistrationConfig || {};
const phoneStates = new Map();
const submittingForms = new WeakSet();
const captchaWidgets = new WeakMap();
let recaptchaLoader = null;
let detectedCountryIso = '';

const routeKeys = [
	'tham-my-chuan-han',
	'thanh-xuan',
	'jw-tham-my-dang-cap-chuan-han',
	'laser-seo',
	'ldp-boc-rang-su',
	'jw-tang-voucher-tri-an-khach-hang-mua-goi-tam-soat-suc-khoe',
	'tam-soat-suc-khoe',
	'su-kien-sinh-nhat-benh-vien-jw-2025',
	'jw-do-bo-binh-phuoc',
	'jw-mung-doc-lap-giam-don-dap',
	'hoi-thao-tham-my-noi-khoa',
	'nang-nguc-noi-soi-ai',
	'meso-baby-skin',
	'jw-tri-an-95-nam-phu-nu-viet-nam',
	'jw-tri-an-phai-dep-0-dong',
	'lieu-trinh-jw-mela-plus',
	'ldp-giang-sinh-lung-linh',
	'tet-nhan-van-2026',
	'tet-dep-0-dong',
	'tet-gieo-que-2026',
	'thang-phai-dep-2026',
	'trong-rang-implant-2026',
	'phu-trang-rang-2026',
	'tinh-hoa-han-viet-2026',
	'tham-my-khong-phau-thuat-2026',
	'nang-nguc-0-dong-2026',
	'phau-thuat-ham-2026',
	'tam-soat-spotmas-10-2026',
	'sinh-nhat-benh-vien-jw-26-nam',
	'hoi-thao-j-plasma-2026',
	'chuong-trinh-uu-dai-sinh-nhat-jw-26-nam',
	'hoi-thao-tre-hoa-dien-mao-trung-nien',
	'jw-chao-mien-dong',
];

function getActionUrl() {
	const path = window.location.pathname.replace(/\/$/, '');
	const route = routeKeys.find((key) => path.includes(key));

	return route && config.registrationEndpoint
		? `${config.registrationEndpoint}?route=${encodeURIComponent(route)}`
		: '';
}

function getUtmSource() {
	const source = new URLSearchParams(window.location.search).get(
		'utm_source'
	);
	return source ? source.toLowerCase().trim().replace(/\s/g, '+') : 'website';
}

function isFormOffCookie(form) {
	if (config.offCookie === true || config.offCookie === 'true') {
		return true;
	}

	const source = getUtmSource();
	return source === 'truc_tiep' || source === 'truc+tiep';
}
function setCookie(name, value, minutes) {
	const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
	document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

function getCookie(name) {
	const cookie = document.cookie
		.split(';')
		.map((item) => item.trim())
		.find((item) => item.startsWith(`${name}=`));

	return cookie ? cookie.slice(name.length + 1) : null;
}

function captureInitialGclid() {
	const urlGclid =
		new URLSearchParams(window.location.search).get('gclid')?.trim() || '';
	const configGclid =
		typeof config.gclid === 'string' ? config.gclid.trim() : '';

	return urlGclid || configGclid;
}

const initialGclid = captureInitialGclid();

function getGclid(form) {
	const inputGclid = form?.querySelector('[name="gclid"]')?.value.trim();
	if (inputGclid) {
		return inputGclid;
	}
	return captureInitialGclid() || initialGclid || '';
}

function showLoader() {
	let loader = document.getElementById('spinner-loader');
	if (!loader) {
		loader = document.createElement('div');
		loader.id = 'spinner-loader';
		loader.setAttribute('aria-hidden', 'true');
		loader.innerHTML = `
			<div class="loader-overlay">
				<div class="loader-spinner" role="status" aria-live="polite">
					<div class="spinner" aria-hidden="true"></div>
					<p>Đang gửi thông tin...</p>
				</div>
			</div>
		`;
		document.body.appendChild(loader);
	}
	loader.style.display = 'block';
	loader.setAttribute('aria-hidden', 'false');
}

function hideLoader() {
	const loader = document.getElementById('spinner-loader');
	if (loader) {
		loader.style.display = 'none';
		loader.setAttribute('aria-hidden', 'true');
	}
}

function closeSuccessModal() {
	const modal = document.getElementById('successModal');
	if (modal) {
		modal.classList.remove('show');
	}
}

function hasSuccessModal() {
	return Boolean(document.getElementById('successModal'));
}

function showSuccessModal(campaign) {
	const modal = document.getElementById('successModal');
	if (!modal) {
		return;
	}

	modal.classList.add('show');
	const eventName = modal.dataset.eventName;
	const eventId = modal.dataset.eventId;
	const conversionId = modal.dataset.conversionId;
	let attempts = 0;
	const gtagTimer = window.setInterval(() => {
		attempts += 1;
		if (typeof window.gtag === 'function' && window.dataLayer) {
			window.clearInterval(gtagTimer);
			if (eventName && eventId) {
				window.gtag('event', eventName, {
					send_to: eventId,
					campaign,
					form_name: 'theForm',
					event_label: 'Success Modal',
					value: 1,
				});
			}
			if (conversionId) {
				window.gtag('event', 'conversion', {
					send_to: conversionId,
					event_timeout: 2000,
				});
			}
		} else if (attempts >= 10) {
			window.clearInterval(gtagTimer);
		}
	}, 300);

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		eventCategory: 'Form Submission',
		eventAction: 'Registration Success',
		eventLabel: 'Success Modal',
		campaign,
		formType: 'Registration',
		timestamp: new Date().toISOString(),
		pageUrl: window.location.href,
		pagePath: window.location.pathname,
	});
	window.dataLayer.push({
		event: 'formSubmissionSuccess',
		formName: 'campaign',
		conversionValue: 1,
	});
}

async function fetchBootstrap() {
	if (!config.ajaxUrl || !config.bootstrapAction) {
		throw new Error('Thiếu cấu hình bootstrap form.');
	}

	const body = new URLSearchParams({ action: config.bootstrapAction });
	const response = await fetch(config.ajaxUrl, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
		},
		body,
	});
	const payload = await response.json();

	if (!response.ok || !payload.success || !payload.data) {
		throw new Error(payload?.data?.message || 'Không thể khởi tạo form.');
	}

	return payload.data;
}

function isLocalhost() {
	const hostname = window.location.hostname || '';
	return (
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '::1' ||
		hostname.endsWith('.test') ||
		hostname.endsWith('.ddev.site') ||
		hostname.endsWith('.local') ||
		hostname.endsWith('.internal')
	);
}

function getCaptchaSiteKey(bootstrap = {}) {
	if (isLocalhost()) {
		return '';
	}

	return (
		window.c4wpConfig?.site_key ||
		bootstrap.recaptcha_site_key ||
		config.recaptchaSiteKey ||
		config.captchaSiteKey ||
		''
	);
}

function loadRecaptcha(siteKey) {
	if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
		return Promise.resolve(window.grecaptcha);
	}
	if (!siteKey) {
		return Promise.reject(new Error('Thiếu CAPTCHA site key.'));
	}
	if (recaptchaLoader) {
		return recaptchaLoader;
	}

	recaptchaLoader = new Promise((resolve, reject) => {
		const callbackName = '__jwRecaptchaV2Callback';
		const onReady = () => {
			if (window.grecaptcha) {
				window.grecaptcha.ready(() => resolve(window.grecaptcha));
			} else {
				recaptchaLoader = null;
				reject(new Error('Không tải được CAPTCHA.'));
			}
		};

		window[callbackName] = onReady;

		const existingScript = document.querySelector(
			'script[src*="recaptcha/api.js"]'
		);
		if (existingScript) {
			if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
				resolve(window.grecaptcha);
				return;
			}
			if (window.grecaptcha?.ready) {
				window.grecaptcha.ready(() => resolve(window.grecaptcha));
				return;
			}
			existingScript.addEventListener('load', onReady);
			existingScript.addEventListener('error', () => {
				recaptchaLoader = null;
				reject(new Error('Không tải được CAPTCHA.'));
			});
			return;
		}

		const loadScript = (domain) => {
			const script = document.createElement('script');
			script.src = `https://${domain}/recaptcha/api.js?onload=${callbackName}&render=explicit&hl=vi`;
			script.async = true;
			script.defer = true;
			script.onerror = () => {
				script.remove();
				if (domain === 'www.google.com') {
					loadScript('www.recaptcha.net');
				} else {
					recaptchaLoader = null;
					reject(new Error('Không tải được CAPTCHA.'));
				}
			};
			document.head.appendChild(script);
		};

		loadScript('www.google.com');
	});

	return recaptchaLoader;
}

function renderCaptcha(form, siteKey, grecaptcha) {
	if (captchaWidgets.has(form)) {
		return captchaWidgets.get(form);
	}

	let container = form.querySelector(
		'.jw-captcha-placement, .c4wp_captcha_field, .g-recaptcha'
	);
	if (!container) {
		container = document.createElement('div');
		container.className = 'jw-captcha-placement';
		const submitBtn = form.querySelector('.btn-submit, [type="submit"]');
		if (submitBtn && submitBtn.parentNode) {
			submitBtn.parentNode.insertBefore(container, submitBtn);
		} else {
			form.appendChild(container);
		}
	}

	if (container.querySelector('iframe')) {
		return null;
	}

	const targetElement =
		container.querySelector('.c4wp_captcha_field_div') || container;

	try {
		const widgetId = grecaptcha.render(targetElement, {
			sitekey: siteKey,
			theme: 'light',
		});
		captchaWidgets.set(form, widgetId);
		return widgetId;
	} catch (err) {
		console.warn('[EventRegistration] Không thể render reCAPTCHA v2:', err);
		return null;
	}
}

function resetCaptcha(form) {
	if (!window.grecaptcha || typeof window.grecaptcha.reset !== 'function') {
		return;
	}
	const widgetId = captchaWidgets.get(form);
	try {
		if (widgetId !== null && widgetId !== undefined) {
			window.grecaptcha.reset(widgetId);
		} else {
			window.grecaptcha.reset();
		}
	} catch (err) {
		console.warn('[EventRegistration] Không thể reset reCAPTCHA v2:', err);
	}
}

async function getCaptchaToken(form, siteKey) {
	let widgetId = captchaWidgets.get(form);

	if (siteKey) {
		const grecaptcha = await loadRecaptcha(siteKey);
		if (widgetId === undefined && grecaptcha?.render) {
			widgetId = renderCaptcha(form, siteKey, grecaptcha);
		}
	}

	let token = '';
	if (
		widgetId !== null &&
		widgetId !== undefined &&
		window.grecaptcha &&
		typeof window.grecaptcha.getResponse === 'function'
	) {
		token = window.grecaptcha.getResponse(widgetId);
	} else if (
		window.grecaptcha &&
		typeof window.grecaptcha.getResponse === 'function'
	) {
		token = window.grecaptcha.getResponse();
	}

	if (!token) {
		const existingResponse = form.querySelector(
			'.c4wp_response, [name="g-recaptcha-response"]'
		);
		if (existingResponse?.value) {
			token = existingResponse.value;
		}
	}

	const responseInput = form.querySelector(
		'.c4wp_response, [name="g-recaptcha-response"]'
	);
	if (responseInput && token) {
		responseInput.value = token;
	}

	return token;
}

function setPhoneError(form, message = '') {
	const error = form.querySelector('.jw-phone-error');
	if (error) {
		error.textContent = message;
	}
}

function initializePhoneInputs(forms) {
	forms.forEach((form) => {
		const input = form.querySelector('[data-international-phone="true"]');
		if (!input || phoneStates.has(form)) {
			return;
		}

		const state = {
			applyingCountry: false,
			interacted: false,
			instance: intlTelInput(input, {
				countryOrder: ['vn'],
				countrySearch: false,
				initialCountry: 'vn',
				separateDialCode: true,
				strictMode: false,
			}),
		};
		input.addEventListener('input', () => {
			state.interacted = true;
			setPhoneError(form);
		});
		input.addEventListener('blur', () => {
			if (input.value.trim()) {
				const validation = validatePhoneNumber(form);
				if (!validation.isValid) {
					setPhoneError(form, validation.message);
				} else {
					setPhoneError(form);
				}
			}
		});
		input.addEventListener('countrychange', () => {
			if (!state.applyingCountry) {
				state.interacted = true;
			}
			setPhoneError(form);
		});
		phoneStates.set(form, state);
	});
}

function applyDetectedCountry(countryIso) {
	const country =
		typeof countryIso === 'string' ? countryIso.toLowerCase() : '';
	detectedCountryIso = country.toUpperCase();
	if (!/^[a-z]{2}$/.test(country)) {
		return;
	}

	phoneStates.forEach((state) => {
		if (state.interacted) {
			return;
		}
		state.applyingCountry = true;
		state.instance.setSelectedCountry(country);
		state.applyingCountry = false;
	});
}

function validatePhoneNumber(form) {
	const state = phoneStates.get(form);
	const input = form.querySelector('[name="telNumber"]');
	if (!state || !input) {
		return { isValid: false, message: 'Không tìm thấy trường số điện thoại.' };
	}

	const rawValue = input.value.trim();
	if (!rawValue) {
		return { isValid: false, message: 'Vui lòng nhập số điện thoại.' };
	}

	const country = state.instance.getSelectedCountry();
	if (detectedCountryIso === 'VN' && country?.iso2 !== 'vn') {
		return {
			isValid: false,
			message: 'Vui lòng chọn mã Việt Nam (+84) cho truy cập từ Việt Nam.',
		};
	}

	const isValid = state.instance.isValidNumber();
	if (!isValid) {
		const errorCode =
			typeof state.instance.getValidationError === 'function'
				? state.instance.getValidationError()
				: -1;

		let message = 'Số điện thoại không hợp lệ với quốc gia đã chọn.';
		switch (errorCode) {
			case 1:
				message = 'Mã quốc gia không hợp lệ.';
				break;
			case 2:
				message = 'Số điện thoại quá ngắn so với mã quốc gia đã chọn.';
				break;
			case 3:
				message = 'Số điện thoại quá dài so với mã quốc gia đã chọn.';
				break;
			case 4:
				message = 'Số điện thoại chứa ký tự không hợp lệ.';
				break;
			case 5:
				message = 'Độ dài số điện thoại không đúng chuẩn quốc gia.';
				break;
			default:
				message = 'Số điện thoại không hợp lệ với mã quốc gia đã chọn.';
		}
		return { isValid: false, message };
	}

	if (country?.iso2 === 'vn') {
		const nationalNumber = input.value.replace(/\D/g, '').replace(/^84/, '');
		const normalized = nationalNumber.startsWith('0')
			? nationalNumber
			: `0${nationalNumber}`;
		const vnMobilePattern = /^0(3[2-9]|5[25689]|7[06-9]|8[1-9]|9\d)\d{7}$/;
		if (!vnMobilePattern.test(normalized)) {
			return {
				isValid: false,
				message:
					'Đầu số di động Việt Nam không đúng định dạng (03, 05, 07, 08, 09).',
			};
		}
	}

	return { isValid: true, country, number: state.instance.getNumber() };
}

async function getPhonePayload(form) {
	const state = phoneStates.get(form);
	const input = form.querySelector('[name="telNumber"]');
	if (!state || !input?.value.trim()) {
		return null;
	}

	await state.instance.promise;
	const validation = validatePhoneNumber(form);
	if (!validation.isValid) {
		setPhoneError(form, validation.message);
		return null;
	}

	setPhoneError(form);
	return {
		country: validation.country?.iso2?.toUpperCase() || '',
		number: validation.number,
	};
}

function initializeScrolling() {
	document.querySelectorAll('.scroll-to').forEach((link) => {
		link.addEventListener('click', (event) => {
			event.preventDefault();
			const target = document.querySelector(link.dataset.target);
			if (target) {
				window.scrollTo({
					top:
						target.getBoundingClientRect().top +
						window.scrollY -
						180,
					behavior: 'smooth',
				});
			}
		});
	});
}

async function submitForm(form) {
	if (submittingForms.has(form)) {
		return;
	}

	const fullName =
		form.querySelector('[name="fullName"]')?.value.trim() || '';
	const serviceInput = form.querySelector('[name="service"]');
	const service = serviceInput?.value || '';
	const campaign = form.querySelector('[name="campaign"]')?.value || '';
	const appointmentInput = form.querySelector('[name="appointment"]');
	const appointment = appointmentInput?.value || '';
	const missing = [];

	if (!fullName) {
		missing.push('Họ tên');
	}
	if (!form.querySelector('[name="telNumber"]')?.value.trim()) {
		missing.push('Số điện thoại');
	}
	if (
		serviceInput &&
		(!service || service === 'null' || service === 'Không chọn')
	) {
		missing.push('Dịch vụ');
	}
	if (appointmentInput && !appointment) {
		missing.push('Ngày đặt hẹn');
	}
	if (missing.length) {
		window.alert(`Vui lòng nhập: ${missing.join(', ')}`);
		return;
	}

	const isOffCookie = isFormOffCookie(form);
	const cookieName = `form_submitted_${encodeURIComponent(campaign)}`;
	if (!isOffCookie && getCookie(cookieName)) {
		window.alert('Bạn đã đăng ký gần đây. Vui lòng chờ 2 phút để gửi lại.');
		return;
	}

	const phone = await getPhonePayload(form);
	if (!phone) {
		return;
	}

	const actionUrl = getActionUrl();
	if (!actionUrl) {
		window.alert('Không xác định được đường dẫn xử lý form.');
		return;
	}

	submittingForms.add(form);
	showLoader();
	try {
		const bootstrap = await fetchBootstrap();
		const siteKey = getCaptchaSiteKey(bootstrap);
		console.log('[EventRegistration] CAPTCHA siteKey:', siteKey ? `${siteKey.substring(0, 10)}...` : '(không có)', {
			source: window.c4wpConfig?.site_key
				? 'window.c4wpConfig'
				: bootstrap?.recaptcha_site_key
				? 'bootstrap'
				: config?.recaptchaSiteKey || config?.captchaSiteKey
				? 'config'
				: 'none',
		});

		let recaptchaToken = '';
		if (isLocalhost()) {
			console.log(
				'[EventRegistration] Môi trường localhost, tự động bỏ qua CAPTCHA.'
			);
		} else if (siteKey) {
			try {
				recaptchaToken = await getCaptchaToken(form, siteKey);
				console.log(
					'[EventRegistration] CAPTCHA token:',
					recaptchaToken
						? `${recaptchaToken.substring(0, 15)}... (length: ${recaptchaToken.length})`
						: '(trống)'
				);
			} catch (captchaError) {
				console.warn(
					'[EventRegistration] Không thể lấy CAPTCHA token:',
					captchaError
				);
			}

			if (!recaptchaToken) {
				hideLoader();
				submittingForms.delete(form);
				window.alert(
					'Vui lòng xác thực "Tôi không phải là người máy" (reCAPTCHA) trước khi gửi.'
				);
				return;
			}
		} else {
			console.log(
				'[EventRegistration] Bỏ qua CAPTCHA do không tìm thấy siteKey.'
			);
		}
		const formData = new FormData();
		formData.append('fullName', fullName);
		formData.append('telNumber', phone.number);
		formData.append('phone_country', phone.country);
		formData.append('service', service);
		formData.append('source', getUtmSource());
		formData.append('city', '');
		formData.append(
			'gift_result',
			form.querySelector('[name="gift_result"]')?.value || ''
		);
		formData.append('campaign', campaign);
		formData.append('appointment', appointment);
		formData.append(
			'department',
			form.querySelector('[name="department"]')?.value || ''
		);
		formData.append(
			'department_nhanvien',
			form.querySelector('[name="department_nhanvien"]')?.value || ''
		);
		formData.append(
			'website_url',
			form.querySelector('[name="website_url"]')?.value || ''
		);
		formData.append('gclid', getGclid(form));
		formData.append('nonce', bootstrap.nonce);
		if (recaptchaToken) {
			formData.append('g-recaptcha-response', recaptchaToken);
			formData.append('c4wp_response', recaptchaToken);
			formData.append('recaptcha_token', recaptchaToken);
		}

		const response = await fetch(actionUrl, {
			method: 'POST',
			body: formData,
		});
		const rawText = await response.text();
		let payload = null;
		try {
			payload = JSON.parse(rawText);
		} catch {
			console.error(
				'[EventRegistration] Phản hồi không phải JSON hợp lệ:',
				rawText
			);
			throw new Error('Lỗi máy chủ: ' + rawText);
		}
		if (!response.ok || !payload || payload.status !== 'success') {
			throw new Error(
				payload?.message || 'Đã xảy ra lỗi. Vui lòng thử lại sau.'
			);
		}

		if (!isOffCookie) {
			setCookie(cookieName, '1', 2);
		}
		form.reset();
		phoneStates.get(form)?.instance.setNumber('');
		resetCaptcha(form);

		if (hasSuccessModal()) {
			window.setTimeout(() => {
				closeSuccessModal();
				showSuccessModal(campaign);
			}, 300);
		} else if (payload.redirect) {
			window.location.href = payload.redirect;
		} else if (payload.message) {
			window.alert(payload.message);
		}
	} catch (error) {
		resetCaptcha(form);
		window.alert(
			error instanceof Error
				? error.message
				: 'Đã xảy ra lỗi. Vui lòng thử lại sau.'
		);
	} finally {
		hideLoader();
		submittingForms.delete(form);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const forms = Array.from(
		document.querySelectorAll('form[data-form="auto"]')
	);
	initializeScrolling();
	initializePhoneInputs(forms);

	forms.forEach((form) => {
		if (isFormOffCookie(form)) {
			form.dataset.offCookie = 'true';
		}

		form.addEventListener('submit', (event) => {
			event.preventDefault();
			void submitForm(form);
		});

		const submitBtn = form.querySelector('.btn-submit');
		if (submitBtn && submitBtn.type !== 'submit') {
			submitBtn.addEventListener('click', (event) => {
				event.preventDefault();
				void submitForm(form);
			});
		}
	});

	const initCaptcha = (siteKey) => {
		if (!siteKey || isLocalhost()) {
			return Promise.resolve();
		}
		return loadRecaptcha(siteKey).then((grecaptcha) => {
			forms.forEach((form) => {
				renderCaptcha(form, siteKey, grecaptcha);
			});
		});
	};

	const earlySiteKey = getCaptchaSiteKey();
	if (earlySiteKey) {
		initCaptcha(earlySiteKey).catch(() => {});
	}

	fetchBootstrap()
		.then((bootstrap) => {
			applyDetectedCountry(bootstrap.country_iso);
			if (isLocalhost()) {
				return null;
			}
			const siteKey = getCaptchaSiteKey(bootstrap);
			if (siteKey) {
				return initCaptcha(siteKey);
			}
			return null;
		})
		.catch(() => {
			// Giữ mặc định Việt Nam; submit sẽ hiển thị lỗi nếu bootstrap vẫn thất bại.
		});

	document
		.querySelector('.success-modal-close')
		?.addEventListener('click', (event) => {
			event.preventDefault();
			closeSuccessModal();
		});
});

document.addEventListener('click', (event) => {
	const modal = document.getElementById('successModal');
	if (event.target === modal) {
		closeSuccessModal();
	}
});

window.closeSuccessModal = closeSuccessModal;
